<script setup lang="ts">
import BaseIcon from '@/components/ui/icon/BaseIcon.vue'
import Skeleton from '@/components/Skeleton.vue'

defineProps({
	titleMercari: {
		type: String,
		required: true,
	},
	productName: {
		type: String,
		required: true,
	},
	isLoading: {
		type: Boolean,
		default: true,
	},
})
</script>

<template>
	<template v-if="isLoading">
		<Skeleton class="h-24px w-[120px]"></Skeleton>
		<div class="mt-16px flex flex-wrap gap-8px">
			<template v-for="i in 3">
				<Skeleton class="h-[30px] w-[120px] basis-full"></Skeleton>
			</template>
		</div>
	</template>
	<template v-else>
		<div class="flex items-center gap-[10px]">
			<div class="rounded-lg bg-b-5% p-[6px] mdp:p-4px">
				<BaseIcon
					name="mercari_logo"
					class="h-20px w-20px mdp:h-16px mdp:w-16px"
				/>
			</div>
			<p class="typography-s1-emp text-[#FF0211]">{{ titleMercari }}</p>
		</div>

		<h1 class="typography-h4-str mt-16px">
			{{ productName }}
		</h1>
	</template>
</template>
